<script setup lang="ts">
export type NavIconName =
  | 'home'
  | 'rate-card'
  | 'quotes'
  | 'order-forms'
  | 'activities'
  | 'commissions'
  | 'financials'
  | 'approvals'
  | 'template'
  | 'users'
  | 'sign-out'
  | 'collapse'
  | 'expand'
  | 'menu'
  | 'close';

defineProps<{ name: NavIconName; size?: number }>();

const PATHS: Record<NavIconName, string[]> = {
  home: ['M3 10.5 12 3l9 7.5', 'M5 9.5V21h14V9.5', 'M10 21v-6h4v6'],
  'rate-card': [
    'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z',
    'M7.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3z',
  ],
  quotes: [
    'M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z',
    'M14 3v6h6',
    'M8 13h8M8 17h5',
  ],
  'order-forms': [
    'M9 2h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z',
    'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2',
    'm9 14 2 2 4-4',
  ],
  activities: ['M22 12h-4l-3 9L9 3l-3 9H2'],
  financials: ['M4 20V10M10 20V4M16 20v-7M22 20H2', 'M15 8l3-3 3 3'],
  commissions: [
    'M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18z',
    'M15 9.5c-.5-1-1.6-1.5-3-1.5-1.7 0-3 .9-3 2s1.3 1.7 3 2 3 .9 3 2-1.3 2-3 2c-1.4 0-2.5-.5-3-1.5M12 6v2M12 16v2',
  ],
  approvals: ['M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18z', 'm8.5 12 2.5 2.5 4.5-5'],
  template: [
    'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z',
    'M3 9h18M9 21V9',
  ],
  users: [
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
    'M9 3a4 4 0 1 0 0 8 4 4 0 1 0 0-8z',
    'M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  ],
  'sign-out': [
    'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4',
    'm16 17 5-5-5-5M21 12H9',
  ],
  collapse: ['m11 17-5-5 5-5M18 17l-5-5 5-5'],
  expand: ['m13 17 5-5-5-5M6 17l5-5-5-5'],
  menu: ['M4 6h16M4 12h16M4 18h16'],
  close: ['M18 6 6 18M6 6l12 12'],
};
</script>

<template>
  <svg
    :width="size ?? 20"
    :height="size ?? 20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    class="shrink-0"
  >
    <path v-for="path in PATHS[name]" :key="path" :d="path" />
  </svg>
</template>
